document.addEventListener("DOMContentLoaded", (event) => {
  const rencentlyTabs = document.querySelectorAll('.recently-viewed .tabs-container input');
  if (rencentlyTabs) {
    rencentlyTabs.forEach(recentTab => {
          if (recentTab.checked) {
              document.querySelector('.recently-viewed .content' + recentTab.dataset.recentlyTab).style.display = 'block';
          }
          recentTab.addEventListener('change', (e) => {
              let contents = document.querySelectorAll('.recently-viewed .recent-tab');
              contents.forEach(content => {
                  content.style.display = 'none';
              })
              document.querySelector('.recently-viewed .content' + recentTab.dataset.recentlyTab).style.display = 'block';
          })
      })
  }
});

const recently_viewed_section = document.querySelector('.recently-viewed');

const options = {
	rootMargin: '100px'
}

const recentlyObserver = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

      recentlyObserver.unobserve(recently_viewed_section)

        let rec_prods = localStorage.getItem(window.Shopify.shop.replace(/.myshopify.com/g,'') + '-recentlyViewedProductHandles');
        if (rec_prods) {
            rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');

            let recently_viewed = document.querySelector('.recently-viewed-slider');
            rec_prods_arr.forEach(rec_prod => {
                let handle = rec_prod.replace(/"/g,'');

                fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=gb-product-card`)
                  .then(response => {
                    if (response.ok) {
                      return response.text();
                    } else {
                      throw new Error("Error: " + response.status);
                    }
                  })
                  .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const productCard = htmlDocument.documentElement.querySelector(".product-card");
                    const productTitle = productCard.querySelector(".product-title");
                    if (productTitle.innerHTML !== "") {
                      let url = window.location.href + "#";
                      let swiper_slide = document.createElement("div");
                      swiper_slide.classList.add('swiper-slide');
                      swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                      if (productCard !== url) {
                        recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                      }
                    }

                    const recent_swiper = new window.swiper('.recently-swiper', {
                      slidesPerView: 1.2,
                      spaceBetween: 44,
                      breakpoints: {
                        450: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        1028: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                        1280: {
                          slidesPerView: 5,
                          spaceBetween: 20,
                        },
                      },
                      navigation: {
                        nextEl: '.recently-swiper-button-next',
                        prevEl: '.recently-swiper-button-prev',
                      },
                    });
                  })
                  .catch(error => {
                    console.error(error);
                  });

            });

            document.querySelector('.recently-viewed label[for="recentTab1"]').click();

        } else {
            document.querySelector('.recently-viewed label[for="recentTab1"]').style.paddingRight = '0';
            document.querySelector('.recently-viewed #recentTab1').style.display = 'none';
            document.querySelector('.recently-viewed label[for="recentTab1"]').style.display = 'none';
            document.querySelector('.recently-viewed label[for="recentTab2"]').click();
        }

        // Init section settings collection swiper
        const coll_swiper = new window.swiper('.best-sellers-swiper', {
            slidesPerView: 1.2,
            spaceBetween: 44,
            breakpoints: {
              450: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1028: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1280: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            },
            navigation: {
              nextEl: '.bestsellers-swiper-button-next',
              prevEl: '.bestsellers-swiper-button-prev',
            },
        });
    }


}, options)

recentlyObserver.observe(recently_viewed_section)